export default __webpack_public_path__ + "static/media/no_icon@2x.e72d574c.png";